export default __webpack_public_path__ + "static/media/icon_building_2_white.f61b74e5.svg";